<template>
  <div v-if="posListAvailable" class="pos-list-wrapper">
    <h1>{{$t('pos.heading')}}</h1>
    <p class="info">
      {{$t('pos.info')}}
    </p>
    <div class="pos-list">
      <div v-for="city in cities" :key="city.cityGeoId">
        <h3 class="city-name">{{ city.name }}</h3>
        <pos-item v-for="record in getCityPos(city.cityGeoId)" :key="record.posId"
          :record="record" />
      </div>
    </div>
  </div>
</template>
<style scoped>
  .city-name {
    color: #40b8b8;
    font-size: 20px;
    margin-bottom: 8px;
  }
</style>

<script>
import { mapState, mapGetters } from 'vuex';
import PosItem from './PosItem.vue';
import OmClient from '../http/OmClient';

export default {
  name: 'pos-list',
  created() {
    this.$root.$on('country-change', this.handleCountryChange);
  },
  computed: {
    ...mapState({
      pos: (state) => state.pos.pos,
      cities: (state) => state.geo.cities,
    }),
    posListAvailable() {
      return !!this.pos;
    },
  },
  data() {
    return {
      omClient: new OmClient(this.getBearerToken()),
    };
  },
  methods: {
    ...mapGetters({
      getBearerToken: 'getBearerToken',
    }),
    handleCountryChange(e) {
      this.omClient.fetchPos(e);
    },
    getCityPos(cityGeoId) {
      return this.pos.filter((pos) => pos.cityGeoId === cityGeoId)
        .sort((a, b) => a.name.localeCompare(b.name));
    },
  },
  components: {
    PosItem,
  },
};
</script>
